import React, { Component } from "react";
import moment from "moment";

export default class TableScore extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: "tab1",
		}
	}

	componentDidMount() {
		const script = document.createElement("script");
		script.src = "assets/js/dataTable-content.js";
		script.async = true;
		document.body.appendChild(script);
	}

	groupingScorePilgan(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "pilihan ganda") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	groupingScorePilganTrueFalse(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "pilihan ganda benar salah") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	groupingScoreEassayShort(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "isian singkat") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	// add value score by type name
	groupingScorePilganKompleks(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "pilihan ganda kompleks") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	groupingScoreEssay(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "uraian") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	groupingScoreMenjodohkan(student) {
		let score = 0;
		Object.values(student.student_answer.case_parts).map((element) => {
			if (element.type_name === "menjodohkan") {
				score = score + element.part_scores;
			}
			return score;
		});
		return score;
	}

	switchTab = (tabName) => {
		this.setState({ activeTab: tabName });
	};

	render() {
		const { activeTab } = this.state;

		return (
			<div>
				{/* Tab Navigation */}
				<div className="tabs">
					<button className={activeTab === "tab1" ? "active" : ""} onClick={() => this.switchTab("tab1")}>
						Summary
					</button>
					<button className={activeTab === "tab2" ? "active" : ""} onClick={() => this.switchTab("tab2")}>
						Detail
					</button>
				</div>

				{/* Tab Content */}
				<div className="tab-content" style={{ display: activeTab === "tab1" ? "block" : "none" }}>
					<table className="table table-bordered text-center nowrap table-hover" id="dt_listScoreStudent" style={{ width: "100%", }}>
						<thead>
							<tr>
								<td className="th-table">Mata Pelajaran</td>
								<td className="th-table">Nama Soal</td>
								<td className="th-table">Tipe</td>
								<td className="th-table">Pilgan</td>
								<td className="th-table">Pilgan B/S</td>
								<td className="th-table">Pilihan Kompleks</td>
								<td className="th-table">Uraian</td>
								<td className="th-table">Isian Singkat</td>
								<td className="th-table">Jodohkan</td>
								<td className="th-table">Total Nilai</td>
							</tr>
						</thead>
						<tbody>
							{Object.values(this.props.listScore).map((element) => (
								<tr key={element.api_schedule_id}>
									<td className="td-table">{element.student_answer.courses.course_name}</td>
									<td className="td-table">{element.student_answer.name}</td>
									<td className="td-table">
										<label className="badge badge-gradient-danger">
											{element.schedules === null ?
												(element.student_answer.flag_remedial ? 'Remedial' : '-')
												: element.schedules.exam_types.exam_type}</label>
									</td>
									<td className="td-table">{parseFloat(this.groupingScorePilgan(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(this.groupingScorePilganTrueFalse(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(this.groupingScorePilganKompleks(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(this.groupingScoreEssay(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(this.groupingScoreEassayShort(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(this.groupingScoreMenjodohkan(element)).toFixed(2)}</td>
									<td className="td-table">{parseFloat(element.student_answer.student_total_scores).toFixed(2)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="tab-content" style={{ display: activeTab === "tab2" ? "block" : "none" }}>
					<table className="table table-bordered text-center nowrap table-hover" style={{ width: "100%", }}>
						<thead>
							<tr>
								<td className="th-table">Hari/Tanggal Ujian</td>
								<td className="th-table">Mata Pelajaran</td>
								<td className="th-table">Total Nilai</td>
								<td className="th-table">Aksi</td>
							</tr>
						</thead>
						<tbody>
							{Object.values(this.props.listScore).map((element) => (
								<tr key={element.api_schedule_id}>
									<td className="td-table">{moment(element.student_answer.updated_at).format("dddd, DD/MM/YYYY")}</td>
									<td className="td-table">{element.student_answer.courses.course_name}</td>
									<td className="td-table">{parseFloat(element.student_answer.student_total_scores).toFixed(2)}</td>
									<td className="td-table">
										{element.student_answer.is_already_corrected === 1 ? (
											<button
												className="btn btn-sm btn-gradient-primary"
												onClick={() => this.props.onViewDetail(element.api_schedule_id)}
											>
												<i className="mdi mdi-magnify mr-1"></i>
												Lihat Detail
											</button>
										) : (
											<span className="text-muted font-italic">Belum Diperiksa</span>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{/* Optional Styling */}
				<style jsx>{`
                    .tabs {
                        display: flex;
                        margin-bottom: 2rem;
                    }
                    .tabs button {
                        margin-right: 10px;
                        padding: 10px 20px;
                        cursor: pointer;
                        border: none;
                        background: #ddd;
                        border-radius: 5px;
                        transition: background 0.5s;
                    }
                    .tabs button.active {
                        background: #9a55ff;
                        color: white;
                    }
                `}</style>
			</div>
		);
	}
}
